import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Campaign, Targeting } from '@feathr/blackbox';
import type { ListResponse } from '@feathr/rachis';
import { TargetAudienceOverview, useAudienceBreakdown, useFlags } from '@feathr/report_components';

import { type IUniqueEmailsResult } from '../AddWizard.useReconcileUniqueEmails';
import AdWizardAudienceStepContent from './AdWizardAudienceStep.Content';
import NewAudience from './AdWizardAudienceStep.NewAudience';

import * as styles from './AdWizardAudienceStep.css';

interface IProps {
  campaign: Campaign;
  targetings: ListResponse<Targeting>;
  emailValidation: IUniqueEmailsResult;
}

function AdWizardAudienceStep({
  campaign,
  targetings: targetingsList,
  emailValidation,
}: Readonly<IProps>): JSX.Element {
  const { showLookalikeAudienceTargeting } = useFlags();
  const { ...audienceData } = useAudienceBreakdown({ targetings: targetingsList, campaign });
  const { hasBuildReachAwarenessPP } = useFlags();

  const { isOmniCampaign } = campaign;
  const isOmniReachCampaign =
    (isOmniCampaign && campaign.get('objective') === 'reach' && hasBuildReachAwarenessPP) ?? false;

  const stepContent = (
    <AdWizardAudienceStepContent
      campaign={campaign}
      emailValidation={emailValidation}
      targetingsList={targetingsList}
    />
  );

  const wrappedStepContent = isOmniCampaign ? (
    <div className={styles.left}>{stepContent}</div>
  ) : (
    stepContent
  );

  return (
    <Flex className={styles.root} justify={isOmniCampaign ? 'space-between' : 'center'}>
      {wrappedStepContent}
      {isOmniCampaign && !isOmniReachCampaign && (
        <div className={styles.right}>
          <TargetAudienceOverview
            isSticky={true}
            showLookalikeAudienceTargeting={showLookalikeAudienceTargeting}
            {...audienceData}
          />
        </div>
      )}

      {isOmniReachCampaign && (
        <div className={styles.right}>
          <NewAudience campaign={campaign} targetings={targetingsList} />
        </div>
      )}
    </Flex>
  );
}

export default observer(AdWizardAudienceStep);
